export default "__VITE_ASSET__COaZjmWJ__"